import { BannerId } from '../../../typings/banners';

export const EDIT_INTERNAL_BANNER = 'EDIT_INTERNAL_BANNER';
export type EDIT_INTERNAL_BANNER = typeof EDIT_INTERNAL_BANNER;

export interface EditInternalBanner {
    type: EDIT_INTERNAL_BANNER;
    bannerId: BannerId;
}

export function editInternalBannerAction(bannerId: BannerId): EditInternalBanner {
    return {
        type: EDIT_INTERNAL_BANNER,
        bannerId
    };
}
